import { createSlice } from "@reduxjs/toolkit";

const cartsSlice = createSlice({
  name: "carts",
  initialState: [],
  reducers: {
    storeCarts(state, action) {
      const carts = action.payload;

      if (carts?.length > 0) {
        carts.map((product) => {
          let existingItem = state.find(
            (item) => item.productId === product.productId
          );
          if (!existingItem) {
            state.push(product);
          }
        });
      }
    },
    addNewItem(state, action) {
      const product = action.payload;

      if (product) {
        let existingItem = state.find((item) => item.productId === product);
        if (!existingItem) {
          state.push({ productId: product, quantity: 1 });
        } else {
          state = state.map((item) => {
            if (item.productId === product) {
              item.quantity += 1;
            }
            return item;
          });
        }
      }
    },
    deleteItem(state, action) {
      const product = action.payload;

      if (product) {
        return state.filter((item) => item.productId !== product);
      }
    },
    updateItem(state, action) {
      const { product, type } = action.payload;

      if (product) {
        if (type === "plus") {
          state = state.map((item) => {
            if (item.productId === product) {
              item.quantity += 1;
            }
            return item;
          });
        } else {
          state = state.map((item) => {
            if (item.productId === product && item.quantity > 1) {
              item.quantity -= 1;
            }
            return item;
          });
        }
      }
    },
  },
});

export const { storeCarts, addNewItem, deleteItem, updateItem } =
  cartsSlice.actions;

export default cartsSlice.reducer;

export const cartsItems = (state) => state.carts;
